import React from "react";
import {} from "prop-types";

const propTypes = {};

const Placeholder = (props) => {
  return (
  <div className="coh-container search-app is-loading coh-style-fluid-max-width">
    <div className="coh-row coh-row-xl coh-row-visible-xl">
      <div className="coh-row-inner search__filters">
        <div className="coh-column coh-visible-sm coh-col-sm-12 coh-visible-xl coh-col-xl-4"></div>
        <div className="coh-column coh-visible-sm coh-col-sm-12 coh-visible-xl coh-col-xl-4"></div>
        <div className="coh-column coh-visible-sm coh-col-sm-12 coh-visible-xl coh-col-xl-4"></div>
      </div>
    </div>
    <div className="coh-container coh-style-padding-bottom-small"> </div>
    <div className="coh-container">
      <div className="coh-row coh-row-xl coh-row-visible-xl">
        <div className="coh-row-inner">
          <div className="coh-column search-app__meta coh-visible-sm coh-col-sm-12 coh-col-sm-push-0 coh-col-sm-pull-0 coh-col-sm-offset-0 coh-col-xl"></div>
          <div className="coh-column search-app__view coh-ce-cpt_search-159b59b8 coh-col-xl"></div>
        </div>
      </div>
    </div>
    <div className="coh-container search-app__results"></div>
  </div>

);
};

Placeholder.propTypes = propTypes;
export default Placeholder;
